import { ApiGet, ApiPost } from './Common.ts'
import { GetOrderEntryConnectorUrl } from '@/stores/SettingsStore.ts'

/**
 * Gets all active security questions
 * @returns Promise with the list of security questions
 */
export async function SecurityQuestionGet() {
  const url = await GetOrderEntryConnectorUrl('GenSecurityQuestionGetConnector')
  return ApiGet(url, {})
}

/**
 * Saves security question responses
 * @param beeBusinessGuid The BeeBusinessGuid of the user
 * @param responses Dictionary with question number as key and response text as value
 * @returns Promise with the save response
 */
export async function SecurityResponseSave(beeBusinessGuid: number, responses: Record<number, string>) {
  const url = await GetOrderEntryConnectorUrl('BeeSecurityResponseSaveConnector')
  
  // Convert the responses object to use decimal keys as specified in the backend
  const decimalResponses: Record<string, string> = {}
  Object.keys(responses).forEach(key => {
    // Convert number keys to decimal format for the backend
    decimalResponses[key] = responses[parseInt(key)]
  })
  
  return ApiPost(url, {
    BeeBusinessGuid: beeBusinessGuid,
    Responses: decimalResponses
  })
}
